import { LocalizedLink as Link } from './LocalizedLink';
import TrustBadges from './TrustBadges';
import { useTranslation } from 'react-i18next';
import '../pages/LandingPage.css';

export default function SiteFooter() {
  const { t } = useTranslation();

  return (
    <footer className="lp-footer">
      <div className="lp-container">
        <div className="lp-footer-grid">
          <div className="lp-footer-brand">
            <div className="lp-footer-logo">
              <img src="/logo.svg?v=2" alt="Reviio Logo" className="lp-logo-img" width={32} height={32} /><span>{` ${t('common.reviio')}`}</span></div>
            <p>{t('footer.aiPoweredGoogleFacebookReviewManagement')}</p>
          </div>
          <div className="lp-footer-col">
            <h3>{t('footer.company')}</h3>
            <Link to="/about">{t('footer.aboutUs')}</Link>
            <Link to="/blog">{t('common.blog')}</Link>
            <Link to="/faq">{t('footer.faq')}</Link>
            <Link to="/security">{t('common.security')}</Link>
          </div>

          <div className="lp-footer-col">
            <h3>{t('footer.product')}</h3>
            <Link to="/#features">{t('footer.featuresOverview')}</Link>
            <Link to="/#pricing">{t('footer.pricingPlans')}</Link>
            <Link to="/#how-it-works">{t('footer.howReviioWorks')}</Link>
            <Link to="/faq">{t('footer.faq')}</Link>
            <Link to="/blog">{t('common.blog')}</Link>
          </div>

          <div className="lp-footer-col">
            <h3>{t('footer.blogCategories')}</h3>
            <Link to="/blog/category/response-and-automation">{t('common.responseAutomation')}</Link>
            <Link to="/blog/category/multi-platform-management">{t('common.multiPlatformManagement')}</Link>
            <Link to="/blog/category/insights-and-action">{t('common.insightsAction')}</Link>
          </div>

          <div className="lp-footer-col">
            <h3>{t('footer.legal')}</h3>
            <Link to="/privacy-policy">{t('common.privacyPolicy')}</Link>
            <Link to="/terms-of-service">{t('common.termsOfService')}</Link>
            <Link to="/cookie-policy">{t('common.cookiePolicy')}</Link>
          </div>
        </div>
        <div className="lp-footer-bottom">
          <TrustBadges />
          <span>{`\u00A9 ${new Date().getFullYear()} ${t('footer.reviioAllRightsReserved')}`}</span>
        </div>
      </div>
    </footer>
  );
}
